import { createSelector } from 'reselect'
// import { List } from 'immutable'

const divisionSelector = state => state.get('division')

export const getIsFetching = createSelector(
  divisionSelector,
  divisionImmutable => {
    const division = divisionImmutable.toJS()
    return division.divisionCreate.isFetching
    || division.divisionEdit.isFetching
    || division.divisionDeactivate.isFetching
    || division.divisionGet.isFetching
    || division.divisionList.isFetching
    || division.divisionExport.isFetching
  }
)
export const getCreateDivisionData = createSelector(
  divisionSelector,
  divisionImmutable => {
    const division = divisionImmutable.toJS()
    return division.divisionCreate
  }
)
export const getEditDivisionData = createSelector(
  divisionSelector,
  divisionImmutable => {
    const division = divisionImmutable.toJS()
    return division.divisionEdit
  }
)
export const getDeactivateDivisionData = createSelector(
  divisionSelector,
  divisionImmutable => {
    const division = divisionImmutable.toJS()
    return division.divisionDeactivate
  }
)
export const getGetDivisionData = createSelector(
  divisionSelector,
  divisionImmutable => {
    const division = divisionImmutable.toJS()
    return division.divisionGet.division
  }
)
export const getListDivision = createSelector(
  divisionSelector,
  divisionImmutable => {
    const division = divisionImmutable.toJS()
    return division.divisionList.division || []
  }
)
export const getExportURL = createSelector(
  divisionSelector,
  divisionImmutable => {
    const division = divisionImmutable.toJS()
    return division.divisionExport.url
  }
)
export const redirectDivision = createSelector(
  divisionSelector,
  divisionImmutable => {
    const division = divisionImmutable.toJS()
    return ({
      redirect: (division.divisionCreate.redirect
      || division.divisionEdit.redirect
      || division.divisionDeactivate.redirect
      || division.divisionGet.redirect
      || division.divisionList.redirect
      || division.divisionExport.redirect),
      isAuthenticated: (division.divisionCreate.isAuthenticated
      || division.divisionEdit.isAuthenticated
      || division.divisionDeactivate.isAuthenticated
      || division.divisionGet.isAuthenticated
      || division.divisionList.isAuthenticated
      || division.divisionExport.isAuthenticated),
    })
  }
)




// WEBPACK FOOTER //
// ./src/selectors/division/division-selector.js